// After a deploy, a tab still running the previous build asks for lazy chunks
// (role routes, pages) whose hashed file names no longer exist. Vite reports
// that as `vite:preloadError`; reloading picks up the new index.html and its
// new chunk names. The timestamp guard stops a reload loop if the chunk is
// genuinely missing — the second failure surfaces to the ErrorBoundary.

const RELOADED_AT_KEY = 'staleChunkReloadedAt';
const RETRY_WINDOW_MS = 10_000;

export const handlePreloadError = (event: Event): void => {
  let reloadedAt = 0;
  try {
    reloadedAt = Number(sessionStorage.getItem(RELOADED_AT_KEY)) || 0;
  } catch {
    // Storage blocked: fall through and reload anyway.
  }
  if (Date.now() - reloadedAt < RETRY_WINDOW_MS) return;

  try {
    sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
  } catch {
    // Without storage there is no loop guard; still better than a dead page.
  }
  event.preventDefault();
  window.location.reload();
};

window.addEventListener('vite:preloadError', handlePreloadError);
